<div class="scanner-container">
    <div class="back-btn d-flex flex-row align-items-start justify-content-start" (click)="dialogRef.close()">
        <div class="back-btn-icon-container d-md-flex justify-content-center align-items-center">
            <mat-icon class="back-btn-icon-container-icon">arrow_back</mat-icon>
        </div>
        <span>Back</span>
    </div>
    <div class="d-md-flex flex-column align-items-center">
        <ngx-scanner-qrcode #scanner="scanner" [config]="cameraConfig" (event)="onEvent($event, scanner)" [hidden]="loading"></ngx-scanner-qrcode>
        <app-spinner [isLoading]="loading" minHeight="5rem" />
        <div class="scanner-container-title mt-5">Position the QR code in the camera frame</div>
    </div>
</div>
